import React from 'react';
import {getRandomArrayElement} from '../../../library';
import {COPY_STRINGS} from '../../../constants/translatedCopy';
import story_badge from "../../../images/EndofAssessmentComp-img-02.svg";

export class EarlyReaderStatus extends React.Component {
  constructor(props) {
    super(props);
    this.goHome = this.goHome.bind(this);
  }

  componentDidMount(){
    const textToSpeak = `${getRandomArrayElement(COPY_STRINGS.onFire)} <break time=\"0.25s\"/> ${COPY_STRINGS.finished_story}`;
    let speechProps = {
      textToSpeak: textToSpeak,
      onEnd: this.goHome,
    };
    this.props.speech.speak(speechProps);
  }

  goHome(){
    this.props.history.push('/student/home');
  }

  render() {
    return (
      <div className="endOfStoryModal">
        <div className="praise">{COPY_STRINGS.great_work}</div>
        <div className="badgeContainer">
          <img className="badge" src={story_badge} alt="" />
        </div>
      </div>
    );
  }
}
